import PageCard from '@/components/general/PageCard';
import React, { useEffect, useState } from 'react';
import styles from '../../styles.module.css';
import { shop } from '@/commonTypes';
import Api from '@/api';
import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import AppLink from '@/components/common/AppLink';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';
import { lightBg, lightBgIcon } from '@/functions/formats';
import MainIcons from '@/icons/main';
import { mockService } from '@/mock/sample.json';

export default function OtherShopServices({ shop }: { shop?: shop }) {
  // ---------------------
  const sample = mockService;
  const fake = Array.from({ length: 4 }, (_, index) => ({
    ...sample,
    id: index + 1,
  }));
  //   ------------------------
  const [otherServices, setOtherServices] = useState([]);
  useEffect(() => {
    if (shop?.id) {
      Api.shopServicesLists({ params: { shopSlug: shop?.slug, start: 0, limit: 3 } })
        .then((res) => {
          setOtherServices(res?.data?.response);
        })
        .catch((err) => {
          console.error('shopServicesLists failed:', err);
        });
    }
  }, [shop]);
  //   ------------------------

  return (
    <PageCard
      noIconWidth={true}
      title={`خدمات دیگر این مرکز`}
      className={`${styles.sectionMargin}`}
    >
      <div className={`${styles.otherServicesList}`}>
        {fake?.map((item, index) => (
          <AppLink href={`/shop-services/${item?.slug}`} title={item?.title}>
            <PageCard
              key={index}
              title={item?.title}
              text={item?.duration}
              aside={
                <PriceSection value={item?.price} className={`${styles.otherServicesPriceClass}`} />
              }
              className={`${styles.otherServicesCard}`}
              backgroundIcon={lightBg(index)}
              icon={<MainIcons.ServiceIcon fill={lightBgIcon(index)} />}
              iconClass={`${styles.otherServicesIcon}`}
              titleClass={`${styles.otherServiceTitle}`}
            />
          </AppLink>
        ))}
      </div>
    </PageCard>
  );
}
